import React, { useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ControlLabel } from "../index";

const useStyles = makeStyles(() => ({
  subtitle: {
    margin: "14px 0",
  },
  latestContainer: {
    marginTop: 2,
    marginLeft: 10,
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#4a4a4a",
    },
    "& .MuiTypography-body1": {
      marginLeft: 4,
      fontSize: 11,
      fontWeight: 500,
      letterSpacing: -0.42,
    },
  },
  radioButton: {
    marginLeft: 3,
  },
  hide: {
    display: "none",
  },
  addressBase: {
    width: 220,
  },
  addressButton: {
    margin: "14px 0", // 주소 검색 버튼을 기본주소 가운데로 맞추기
  },
}));

const convertLabel = (label: string): string => {
  if (label.length > 7) {
    return label.slice(0, 6) + "...";
  }
  return label;
};

export default function LatestAddress(props: any) {
  const classes = useStyles();
  const {
    isDeparture,
    setAddressForm,
    latestAddresses,
    updateSidebar,
    latest,
    setLatest,
  } = props;

  useEffect(() => {
    if (isDeparture && latestAddresses?.length > 0) updateSidebar(0);
  }, [isDeparture, latestAddresses, updateSidebar]);

  return (
    <>
      <ControlLabel name={"최근"} />
      <FormControl component="fieldset" className={classes.latestContainer}>
        <RadioGroup
          sx={{ zIndex: 0 }}
          name={"latest"}
          aria-label={"latest"}
          value={latest}
          onChange={(e: any) => {
            setLatest(e.target.value);
            updateSidebar(parseInt(e.target.value));
            const addressForm = latestAddresses[parseInt(e.target.value)];
            setAddressForm(addressForm); // The DOM API casts this to a string.
          }}
          row
        >
          {latestAddresses?.map((o: any, i: number) => (
            <FormControlLabel
              key={i}
              value={i.toString()} // The DOM API casts this to a string.
              control={<Radio color={"default"} />}
              label={convertLabel(o.name)}
              className={classes.radioButton}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
}
